// import Products1Img from "./images/Products1Img";
// import Products2Img from "./images/Products2Img";
// import Products3Img from "./images/Products3Img";
import Product1_RUS from './/../assets/Products1_RUS.png';
import Product2_RUS from './/../assets/Products2_RUS.png';
import Product3_RUS from './/../assets/Products3_RUS.png';

import Product1_ENG from './/../assets/Products1_ENG.png';
import Product2_ENG from './/../assets/Products2_ENG.png';
import Product3_ENG from './/../assets/Products3_ENG.png';

import Product1_ESP from './/../assets/Products1_ESP.png';
import Product2_ESP from './/../assets/Products2_ESP.png';
import Product3_ESP from './/../assets/Products3_ESP.png';

import Product1_CH from './/../assets/Products1_CH.png';
import Product2_CH from './/../assets/Products2_CH.png';
import Product3_CH from './/../assets/Products3_CH.png';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';

export default function ThreeProducts() {
  const { t, i18n } = useTranslation();

  const mapLang = {ru: [Product1_RUS, Product2_RUS, Product3_RUS], 
    eng: [Product1_ENG, Product2_ENG, Product3_ENG], 
    esp: [Product1_ESP, Product2_ESP, Product3_ESP],
    ch: [Product1_CH, Product2_CH, Product3_CH]
  }

  const raw = (typeof window !== 'undefined' && window.localStorage.getItem('lang')) || i18n.language || 'ru';
    const pack = mapLang[raw] || mapLang.eng; // всегда есть дефолт

  return (
    <section className="w-full grid grid-cols-1 md:grid-cols-2 items-stretch py-10 gap-6 mt-16 text-white px-4 md:portrait:px-10 px-4 lg:px-[100px] min-[1440px]:px-[200px]">
      {/* Карточка 1 */}
      <div className="bg-[#201E1C] min-h-[300px] rounded-2xl flex flex-col">
        <div className="flex-1 p-5">
          <h1 className="gradient-text font-bold mb-4">
            {t("$Product_title1")}
          </h1>
          <p className="font-bold mb-8">{t("$Product_subtitle1")}</p>
          <Trans
            i18nKey="$Product_text1"
            components={{
              p: <p />,
              list: <ul className="list-disc pl-5 space-y-1" />,
              li: <li />,
              p2: <p className="mt-3" />,
              p3: <p className="mt-2" ></p>
            }}
          />
        </div>

        <div>
          <img src={pack[0]} className="w-full h-auto" />
          {/* <Products1Img className="w-full h-auto" /> */}
          <p className="mt-2 p-5">{t("$Product_subtitle12")}</p>
        </div>
      </div>

      {/* Карточка 2 */}
      <div className="bg-[#201E1C] min-h-[300px] rounded-2xl flex flex-col">
        <div className="flex-1 p-5">
          <h1 className="gradient-text font-bold mb-4">
            {t("$Product_title2")}
          </h1>
          <p className="font-bold mb-8">{t("$Product_subtitle2")}</p>
          <Trans 
            i18nKey="$Product_text2"
            components={{ p: <p />,
                          list: <ul className="list-disc pl-5 space-y-1"></ul>,
                          li: <li></li>,
                          p2: <p className="mt-3" />,
                          p3: <p className="mt-2" />
             }}
          />
        </div>
        <img src={pack[1]} className="w-full h-auto" />
        {/* <Products2Img className="w-full h-auto" /> */}
      </div>

      {/* Карточка 3 — на мобиле одна колонка, на md занимает две */}
      <div className="bg-[#201E1C] col-span-1 md:col-span-2 min-h-[300px] rounded-2xl
                flex flex-col md:flex-row md:justify-between md:items-start gap-6">
        <div className="flex flex-col p-5">
          <div className='flex-1'>
            <h1 className="gradient-text font-bold mb-4">
              {t('$Product_title3')}
            </h1>
            <p className="font-bold">{t('$Product_subtitle3')}</p>
          </div>
          <div className="mt-4">

             <Trans 
            i18nKey="$Product_text3"
            components={{ p: <p />,
                          list: <ul className="list-disc pl-5 space-y-1"></ul>,
                          li: <li></li>,
                          p2: <p className="mt-3" />,
                          p3: <p className="mt-2" />
             }}
          />
          </div>
        </div>

        <img src={pack[2]} className="w-full md:w-3/5 h-auto object-contain md:self-start rounded-2xl shrink-0 md:max-h-[420px]" />
        {/* <Products3Img className="w-full md:w-3/5 h-auto self-end md:self-auto" /> */}
      </div>
    </section>
  );
}
